import { EventEmitter, Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment, isODM} from '../../environments/environment';
import {CryptoService} from './crypto.service';
// 密碼雜湊與 Code 由後端 /api/auth/* BFF 處理（見 RegisterAccount、ChangePassword 等）
import { HttpParams } from '@angular/common/http';
export const STORE_KEY_AuthOtp = 'AuthOtp';
export const STORE_KEY_AuthOtpId = 'AuthOtpId';
export const STORE_KEY_CompanionCode = 'CompanionCode';

@Injectable()
export class AccountService {
  authOtp: string;
  authOtpId: number;
  companionCode: string;
  public apiTwoFactorStatusEmitter: EventEmitter<any> = new EventEmitter<any>();
  public apiAuthOtpEmitter: EventEmitter<any> = new EventEmitter<any>();
  public apiAuthOtpTypeEmitter: EventEmitter<any> = new EventEmitter<any>();
  public upsControlTwoFactorStatusEmitter: EventEmitter<any> = new EventEmitter<any>();
  public upsControlAuthOtpEmitter: EventEmitter<any> = new EventEmitter<any>();
  public upsControlAuthOtpTypeEmitter: EventEmitter<any> = new EventEmitter<any>();
  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  RegisterAccount(data): Observable <any> {
    const params = {...data, isOdm: isODM};
    if (params.Password) {
      params.Password = params.Password.trim();
    }
    return this.http.post<any>('/api/auth/register', params);
  }

  ConfirmAccount(params): Observable <any> {
    return this.http.post<any>(`${environment.apiSerivceUrl}/Personal/api/Service/ConfirmAccount`, params);
  }

  ChangePassword(data): Observable <any> {
    const params = {...data, isOdm: isODM};
    if (params.Password) {
      params.Password = params.Password.trim();
    }
    if (params.NewPassword) {
      params.NewPassword = params.NewPassword.trim();
    }
    return this.http.post<any>('/api/auth/change-password', params);
  }

  ChangeResettingPassword(data): Observable <any> {
    const params = {...data, isOdm: isODM};
    if (params.NewPassword) {
      params.NewPassword = params.NewPassword.trim();
    }
    return this.http.post<any>('/api/auth/change-resetting-password', params);
  }

  ForgetPassword(email): Observable <any> {
    return this.http.post<any>('/api/auth/forgot-password', { account: email.trim() });
  }

  ReadCountryList(): Observable <any> {
    return this.http.get<any>(`${environment.apiSerivceUrl}/Personal/api/Service/ReadWebsiteCountryList`);
  }

  // 調整 Account 頁面使用之 API不從Nodejs拿資料
  // ReadAccountInfo(acode, userAcode): Observable<any> {
  //   return this.http.post<any>(`/api/account`, {acode: acode, userAcode: userAcode, hashCode: this.cryptoService.hashHmacSha512(acode)});
  // }

  // ReadAllAccountInfo(acode): Observable<any> {
  //   return this.http.post<any>(`/api/account/all`, {acode: acode, hashCode: this.cryptoService.hashHmacSha512(acode)});
  // }

  // ReadAccountInfoByRegion(acode, regions): Observable<any> {
  //   return this.http.post<any>(`/api/account/region`,
  // {acode: acode, hashCode: this.cryptoService.hashHmacSha512(acode + regions), regions: regions});
  // }

  ReadAccountInfo(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/account/read`, {otp: otp});
  }

  ReadEndUserAccountInfo(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/Personal/api/Service/ReadClientAccount`,
    {otp: otp}, { headers: new HttpHeaders({ 'Content-Type': 'application/json' })});
  }

  // 調整 Authority 頁面使用之 API不從Nodejs拿資料
  // ReadAllAuthorityInfo(acode): Observable<any> {
  //   return this.http.post<any>(`/api/authority/all`, {acode: acode, hashCode: this.cryptoService.hashHmacSha512(acode)});
  // }

  ReadAllAuthorityInfo(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/authority/read`, {otp: otp});
  }

  ReSendActivationMail(email): Observable<any> {
    const params = {
      account: email.trim(),
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/resendvalidationemail`, params);
  }

  ReadUserActivity(otp: string): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/device/overview`, { otp: otp });
  }

  OAuthLogin(param): Observable<any> {
    // req note: LoginType = 10代表PowerPanel Web Login, 11代表PowerPanel Web Logout
    // NgRx freezes action payloads; do not mutate param in place
    const body = {
      ...param,
      LoginType: 10,
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/oauth/login`, body);
  }

  AddAccountByOAuth(param): Observable<any> {
    const body = {
      ...param,
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/add/oauth`, body);
  }

  AddAccountOAuth(param): Observable<any> {
    const body = {
      ...param,
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/oauth/add`, body);
  }

  ReadAccountOAuth(param): Observable<any> {
    const body = {
      ...param,
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/oauth/read`, body);
  }

  DeleteAccountOAuth(param): Observable<any> {
    const body = {
      ...param,
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/oauth/delete`, body);
  }

  UpdateAccountEmail(param): Observable<any> {
    const body = {
      ...param,
      Code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<any>(`${environment.apiIotUrl}/account/update`, body);
  }

  ExchangeGoogleUserInfo(access_token): Observable<any> {
    return this.http.get<any>(`https://www.googleapis.com/oauth2/v2/userinfo?access_token=${access_token}`);
  }

  GetFacebookAccessToken(code, redirect_uri): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`https://graph.facebook.com/oauth/access_token?client_id=398107632730962&redirect_uri=${redirect_uri}&client_secret=7db39cd42d6de244a0c5564b5f02860f&code=${code}`);
  }

  ExchangeFacebookUserInfo(access_token): Observable<any> {
    const param = {
      access_token: access_token,
      fields: 'id,first_name,last_name,email,picture'
    };
   return this.http.post<any>
   (`https://graph.facebook.com/me`, param);
  }

  AddAuthOTP(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/authotp/add`, param);
  }

  CheckAuthOtp(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/authotp/check`, param);
  }

  EnableAuthOtp(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/account/authotp/enable`, param);
  }

  AddAccountOAuthSW(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/account/oauth/sw/add`, param);
  }

  CheckOtp(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/otp/check`, param);
  }

  set SetAuthOtp(value) {
    localStorage.setItem(STORE_KEY_AuthOtp, value);
    this.authOtp = value;
  }

  get GetAuthOtp() {
    const data = localStorage.getItem(STORE_KEY_AuthOtp);
    return data || '';
  }

  apiTwoFactorStatusTriggerEvent() {
    this.apiTwoFactorStatusEmitter.emit();
  }

  apiAuthOtpEvent() {
    this.apiAuthOtpEmitter.emit();
  }

  apiAuthOtpEventType() {
    this.apiAuthOtpTypeEmitter.emit();
  }

  upsControlTwoFactorStatusTriggerEvent() {
    this.upsControlTwoFactorStatusEmitter.emit();
  }

  upsControlAuthOtpEvent() {
    this.upsControlAuthOtpEmitter.emit();
  }

  upsControlAuthOtpEventType() {
    this.upsControlAuthOtpTypeEmitter.emit();
  }
}

